
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/2020details",
      function () {
        return require("private-next-pages/pricing/2020details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pricing/2020details"])
      });
    }
  